import { HeatingCircuit } from 'z3k-config';
export function getClimaticHeatingCircuitsConfig(heating_circuits) {
    const climatic_shared_heating_circuits = heating_circuits.filter((heating_circuit) => {
        if (!heating_circuit) {
            return false;
        }
        const { z3k_circuit } = heating_circuit;
        if (!z3k_circuit) {
            return false;
        }
        const { type } = z3k_circuit;
        const is_dhw_circuit = type === HeatingCircuit.Type.DHW;
        const is_heating_circuit = type === HeatingCircuit.Type.HEATING;
        const should_display_heating_circuit = (is_dhw_circuit || is_heating_circuit) &&
            HeatingCircuit.isEnabled(z3k_circuit);
        return should_display_heating_circuit;
    });
    return climatic_shared_heating_circuits;
}
